import { WindowLocation } from '@reach/router'
import { mapIndexed } from 'rambdax'
import ZoneContactBoxFieldset, {
  ZoneContactBoxFieldsetProps,
} from '../components/ContactBox/Fieldset'
import ZoneContactBoxLinks, {
  ZoneContactBoxLinksProps,
} from '../components/ContactBox/Links'
import ZoneContactBoxList, {
  ZoneContactBoxListProps,
} from '../components/ContactBox/List'
import ZoneCarousel, { ZoneCarouselProps } from './Carousel/Carousel'
import ZoneColumnContentList, {
  ZoneColumnContentListProps,
} from './ColumnContentList/ColumnContentList'
import {
  ZoneDecodedBanner,
  ZoneDecodedBannerProps,
} from './DecodedBanner/DecodedBanner'
import ZoneDownloadTheApp, {
  ZoneDownloadTheAppProps,
} from './DownloadTheApp/DownloadTheApp'
import ZoneEmbedScript, {
  ZoneEmbedScriptProps,
} from './EmbedScript/EmbedScript'
import {
  ZoneExchangeRateCalculator,
  ZoneExchangeRateCalculatorProps,
} from './ExchangeRateCalculator/ExchangeRateCalculator'
import ZoneFaqBox, { ZoneFaqBoxProps } from './FaqBox/FaqBox'
import ZoneFreeText, { ZoneFreeTextProps } from './FreeText/FreeText'
import ZoneHelp, { ZoneHelpProps } from './Help/Help'
import ZoneIconContentBoxList, {
  ZoneIconContentBoxListProps,
} from './IconContentBoxList/IconContentBoxList'
import ZoneImageRibbon, {
  ZoneImageRibbonProps,
} from './ImageRibbon/ImageRibbon'
import ZoneInlineWaitlist, {
  ZoneInlineWaitlistProps,
} from './InlineWaitlist/InlineWaitlist'
import ZoneInvestors, { ZoneInvestorsProps } from './Investors/Investors'
import ZoneJoinOurTeam, {
  ZoneJoinOurTeamProps,
} from './JoinOurTeam/JoinOurTeam'
import ZoneLatestNews, { ZoneLatestNewsProps } from './LatestNews/LatestNews'
import ZoneMeetCommunity, {
  ZoneMeetCommunityProps,
} from './MeetCommunity/MeetCommunity'
import ZoneMeetupList, { ZoneMeetupListProps } from './MeetupList/MeetupList'
import ZoneMeetups, { ZoneMeetupsProps } from './Meetups/Meetups'
import ZoneNewsList, { ZoneNewsListProps } from './News/NewsList'
import ZoneNewsCategoryNavigation, {
  ZoneNewsCategoryNavigationProps,
} from './NewsCategoryNavigation/NewsCategoryNavigation'
import ZoneTeam, { ZoneTeamProps } from './Team/Team'
import ZoneTextContentBox, {
  ZoneTextContentBoxProps,
} from './TextContentBox/TextContentBox'
import ZoneWideImage, { ZoneWideImageProps } from './WideImage/WideImage'

export type ZoneItemType =
  | ZoneCarouselProps
  | ZoneInvestorsProps
  | ZoneJoinOurTeamProps
  | ZoneMeetCommunityProps
  | ZoneMeetupsProps
  | ZoneMeetupListProps
  | ZoneTeamProps
  | ZoneContactBoxFieldsetProps
  | ZoneContactBoxLinksProps
  | ZoneContactBoxListProps
  | ZoneImageRibbonProps
  | ZoneIconContentBoxListProps
  | ZoneColumnContentListProps
  | ZoneNewsListProps
  | ZoneNewsCategoryNavigationProps
  | ZoneInlineWaitlistProps
  | ZoneFreeTextProps
  | ZoneEmbedScriptProps
  | ZoneLatestNewsProps
  | ZoneDecodedBannerProps
  | ZoneExchangeRateCalculatorProps
  | ZoneHelpProps
  | ZoneFaqBoxProps
  | ZoneWideImageProps
  | ZoneTextContentBoxProps
  | ZoneDownloadTheAppProps

export type ZoneRendererProps = {
  zones: ZoneItemType[]
  location: WindowLocation<{ value: string }>
}

export function getComponentByZoneType(
  zone: ZoneItemType,
  key: string,
  location?: WindowLocation<{ value: string }>
) {
  switch (zone.__typename) {
    case 'StrapiGQL_ComponentZonesTeam':
      return <ZoneTeam key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesInvestorsAndAdvisors':
      return <ZoneInvestors key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesJoinOurTeam':
      return <ZoneJoinOurTeam key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesCarousel':
      return <ZoneCarousel key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesMeetups':
      return <ZoneMeetups key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesMeetupList':
      return <ZoneMeetupList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesMeetCommunity':
      return <ZoneMeetCommunity key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFieldset':
      return <ZoneContactBoxFieldset key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesContactBox':
      return <ZoneContactBoxLinks key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesContactInfoBoxList':
      return <ZoneContactBoxList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesImageRibbon':
      return <ZoneImageRibbon key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesIconContentBoxList':
      return <ZoneIconContentBoxList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesColumnContentList':
      return <ZoneColumnContentList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesNews':
      return <ZoneNewsList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesNewsCategoryNavigation':
      return <ZoneNewsCategoryNavigation key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesInlineWaitlist':
      return <ZoneInlineWaitlist key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFreeText':
      return <ZoneFreeText key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesEmbedScript':
      return <ZoneEmbedScript key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesLatestNews':
      return <ZoneLatestNews key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesDecodedBanner':
      return <ZoneDecodedBanner key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesExchangeRateCalculator':
      return <ZoneExchangeRateCalculator key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesHelp':
      return <ZoneHelp key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesWideImage':
      return <ZoneWideImage key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesTextContentBox':
      return <ZoneTextContentBox key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFaqBox':
      return <ZoneFaqBox key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesDownloadTheApp':
      return <ZoneDownloadTheApp key={key} {...zone} />
    default:
      return null
  }
}
export default function MainZoneRenderer({
  zones,
  location,
}: ZoneRendererProps) {
  return (
    <main>
      {mapIndexed(
        (zone, index) =>
          getComponentByZoneType(zone, `${zone.__typename}-${index}`, location),
        zones
      )}
    </main>
  )
}
